import { loginApi } from '@/api/login'
import * as types from '../mutation-types'
import {
  getSessionId,
  setSessionId,
  removeSessionId,
  getLoginState,
  setLoginState,
  removeLoginState
} from '../../utils/auth'

const state = {
  sessionId: getSessionId(), // session
  loginState: getLoginState() // 登录态
}

const getters = {
  sessionId: state => state.sessionId,
  loginState: state => state.loginState
}

const mutations = {
  [types.RECEIVE_SESSION_ID] (state, sessionId) {
    state.sessionId = sessionId
    if (sessionId === '') {
      removeSessionId()
    } else {
      setSessionId(sessionId)
    }
  },
  [types.RECEIVE_LOGIN_STATE] (state, loginState) {
    state.loginState = loginState
    if (loginState === '') {
      removeLoginState()
    } else {
      setLoginState(loginState)
    }
  }
}

const actions = {
  // 用户名登录
  loginMode ({ commit }, code) {
    return new Promise((resolve, reject) => {
      loginApi(code).then(res => {
        commit(types.RECEIVE_SESSION_ID, res.Data.TokenId)
        commit(types.RECEIVE_LOGIN_STATE, res.Data.IsLogin)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  loginOut ({ commit }) {
    return new Promise(resolve => {
      commit(types.RECEIVE_SESSION_ID, '')
      commit(types.RECEIVE_LOGIN_STATE, '')
      resolve()
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
